import { editorBlockViewFragment } from '@getaccept/editor-lib';
import { UserFragments } from '@getaccept/dsr-shared/src/api/users/graphql/user.fragments';
import gql from 'graphql-tag';

export class DSRQueries {
  static load = gql`
    query Dsr {
      document {
        id
        name
        value
        sendDate
        companyName
        uniqueId
        expirationDate
        createdAt
        pages {
          id
          pageNum
          editorBlock {
            ...editorBlockViewFragment
          }
        }
        documentRevisions {
          message
          revision
          status
          createdAt
          viewedByRecipient
          editorBlockContentVersions {
            blockId
            contentId
          }
        }
        documentAccess {
          accessRule
        }
        user {
          ...userFragment
        }
      }
    }
    ${editorBlockViewFragment}
    ${UserFragments.user}
  `;

  static loadRevisions = gql`
    query DsrRevisions {
      document {
        documentRevisions {
          message
          revision
          status
          createdAt
          viewedByRecipient
        }
      }
    }
  `;

  static loadRecipients = gql`
    query Recipients {
      document {
        id
        recipients {
          companyName
          id
          firstName
          lastName
          fullName
          title
          mobile
          email
          thumbUrl
        }
      }
    }
  `;

  static loadUser = gql`
    query User {
      document {
        id
        user {
          id
          firstName
          lastName
          fullName
          title
          mobile
          email
          thumbUrl
        }
      }
    }
  `;

  static theme = gql`
    query Theme($documentId: String!) {
      theme(documentId: $documentId) {
        name
        backgroundColor
        backgroundImage
        backgroundType
        textColor
        accentColor
        fontSize
        fontFamily
        customCss
        logoUrl
        signButtonText
      }
    }
  `;

  static loadUniversalLink = gql`
    query loadUniversalLink {
      getUniversalLinks {
        url
      }
    }
  `;
}
